<dx-scroll-view class="view-wrapper-scroll">
  <div class="view-wrapper">
    <dx-toolbar class="toolbar-details">
      <dxi-item location="before">
        <dx-button
          class="close-button"
          icon="close"
          (click)="closeClick()"
        ></dx-button>
      </dxi-item>
      <dxi-item location="before" [text]="taskName"></dxi-item>
      <dxi-item location="after" locateInMenu="auto">
        <dx-drop-down-button text="İşlemler" stylingMode="contained">
          <dxi-item text="Kopyala"></dxi-item>
          <dxi-item text="Kapat"></dxi-item>
          <dxi-item text="Sil"></dxi-item>
        </dx-drop-down-button>
      </dxi-item>
      <dxi-item
        location="after"
        locateInMenu="auto"
        widget="dxButton"
        showText="inMenu"
        [options]="{
          text: 'Attach',
          icon: 'attach',
          stylingMode: 'text'
        }"
      ></dxi-item>
      <dxi-item
        location="after"
        locateInMenu="auto"
        widget="dxButton"
        showText="inMenu"
        [options]="{
          text: 'Refresh',
          icon: 'refresh',
          onClick: refresh,
          stylingMode: 'text'
        }"
      ></dxi-item>
    </dx-toolbar>

    <div class="panels">
      <div class="left">
        <dx-validation-group>
          <dk-task-form [task]="task" [isLoading]="isLoading"></dk-task-form>
        </dx-validation-group>
      </div>

      <div class="right">
        <div class="dx-card details-card">
          <dx-tab-panel [showNavButtons]="true" [deferRendering]="false">
            <dxi-item title="Aktiviteler">
              <dk-card-activities
                [isLoading]="isLoading"
                [activities]="task?.activities"
                [showBy]="true"
              ></dk-card-activities>
            </dxi-item>
            <dxi-item title="Notlar">
              <dk-card-notes
                [items]="task?.notes"
                [user]="task?.owner"
              ></dk-card-notes>
            </dxi-item>
            <dxi-item title="Mesajlar" [badge]="task?.messages.length">
              <dk-card-messages
                [items]="task?.messages"
                [user]="task?.owner"
              ></dk-card-messages>
            </dxi-item>
          </dx-tab-panel>
        </div>
      </div>
    </div>
  </div>
</dx-scroll-view>
